import { Controller } from '@stimulus/core';
import debounce from 'lodash/debounce';
import $ from 'jquery';
import Turbolinks from 'turbolinks';
function isTurbolinksWithController(turbolinks) {
    if ('controller' in turbolinks) {
        const { controller } = turbolinks;
        return ('replaceHistoryWithLocationAndRestorationIdentifier' in controller &&
            'restorationIdentifier' in controller);
    }
    return false;
}
/*
 * incremental search を行うコントローラ
 *
 * オプション target でセレクタを指定する。
 */
class ControllerBase extends Controller {
}
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.connected = false;
        this.seq = 0;
    }
    initialize() {
        this.onInput = this.onInput.bind(this);
        this.doFetch = debounce(this.doFetch.bind(this), 300);
    }
    connect() {
        this.connected = true;
        this.form?.addEventListener('input', this.onInput);
    }
    disconnect() {
        this.connected = false;
        this.form?.removeEventListener('input', this.onInput);
    }
    onInput() {
        if (!this.connected)
            return;
        const form = this.form;
        if (!form)
            return;
        const params = $(form).serialize();
        let requestUrl;
        const url = form.action;
        if (url.indexOf('?') >= 0) {
            requestUrl = url + '&' + params;
        }
        else {
            requestUrl = url + '?' + params;
        }
        if (isTurbolinksWithController(Turbolinks)) {
            const { controller } = Turbolinks;
            controller.replaceHistoryWithLocationAndRestorationIdentifier(requestUrl, controller.restorationIdentifier);
        }
        this.doFetch(requestUrl);
    }
    doFetch(requestUrl) {
        this.seq += 1;
        const seq = this.seq;
        return fetch(requestUrl)
            .then(response => {
            if (!this.connected || seq !== this.seq) {
                return Promise.reject();
            }
            if (response.ok) {
                return response.text();
            }
        })
            .then(html => {
            const target = this.target;
            const result = $(html)
                .find(target)
                .html();
            $(target).html(result);
        })
            .catch(error => {
            if (error) {
                console.error(error);
            }
        });
    }
    get form() {
        if (this.element instanceof HTMLFormElement) {
            return this.element;
        }
        else if (this.hasFormTarget) {
            return this.formTarget;
        }
        return null;
    }
    get target() {
        return this.data.get('target');
    }
}
default_1.targets = ['form'];
